import unmaskFormValues from '@/components/formulate/TextInput/lib/unmaskFormValues'
// TODO: use global helpers instead
import { diffObject } from './compare'
import maskFormValues from '@/components/formulate/TextInput/lib/maskFormValues'
import maskFieldValue from '@/components/formulate/TextInput/lib/maskFieldValue'

/**
 * Transform the request payload for store
 * @param {object} payload
 * @param {object} fields
 * @returns {object} transformed payload
 */
export const transformVendorStoreRequest = (payload, fields) => {
  let transformed = unmaskFormValues(payload, fields)

  // since we use checkbox, we need to transform the value
  transformed = {
    ...transformed,
    status: transformed?.status ? 'ACTIVE' : 'INACTIVE',
  }

  return transformed
}

/**
 * Transform the request payload for update, only send the changed data
 * @param {object} newData
 * @param {object} oldData
 * @returns {object} transformed payload
 */
export const transformVendorUpdateRequest = (newData, oldData, fields) => {
  const [diff, _] = diffObject(newData, oldData)

  let transformed = { ...diff }
  transformed = unmaskFormValues(transformed, fields)

  if ('status' in diff) {
    transformed.status = transformed?.status ? 'ACTIVE' : 'INACTIVE'
  }

  return transformed
}

/**
 * Transform the response payload for show
 * @param {object} data
 * @returns {object} transformed payload
 * @todo check show
 * @todo check update
 */
export const transformVendorShowResponse = (data, fields) => {
  let transformed = {}

  const statusMapping = {
    Aktif: true,
    'Non Aktif': false,
  }

  if (data === null) {
    // In create form, show default value
    transformed = { ...data, status: true }
  } else {
    // In show form, use data from API but transform object to boolean
    transformed = { ...data, status: statusMapping[data?.status?.name] }
  }
  transformed = maskFormValues(transformed, fields)

  return transformed
}
